import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;

export const productsAPI = {
  getAll: (params = {}) => {
    // Strip null/undefined/empty values to avoid sending them as literal "null" strings to the backend
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== null && v !== undefined && v !== '')
    );
    return api.get('/products/', { params: cleanParams }).then(r => r.data);
  },
  getById: (id) => api.get(`/products/${id}`).then(r => r.data),
  getFeatured: () => api.get('/products/featured').then(r => r.data),
  getBestsellers: () => api.get('/products/bestsellers').then(r => r.data),
  search: (query) => api.get('/products/search', { params: { q: query } }).then(r => r.data)
};

export const brandsAPI = {
  getAll: () => api.get('/brands/').then(r => r.data),
  getBySlug: (slug) => api.get(`/brands/${slug}`).then(r => r.data)
};

export const categoriesAPI = {
  getAll: (species = null) => api.get('/categories/', { params: species ? { species } : {} }).then(r => r.data),
  getBySlug: (slug) => api.get(`/categories/${slug}`).then(r => r.data)
};

export const ordersAPI = {
  create: (order) => api.post('/orders/', order).then(r => r.data),
  getById: (id) => api.get(`/orders/${id}`).then(r => r.data),
  getByEmail: (email) => api.get(`/orders/email/${email}`).then(r => r.data)
};

export const paymentsAPI = {
  create: (payload) => api.post('/payments/create', payload).then(r => r.data),
  getStatus: (reference) => api.get(`/payments/status/${reference}`).then(r => r.data),
  getConfig: () => api.get('/payments/config').then(r => r.data)
};

export const couponsAPI = {
  validate: (code, subtotal) => api.post('/coupons/validate', { code, subtotal }).then(r => r.data),
  mine: () => api.get('/coupons/mine').then(r => r.data),
};

export const shippingAPI = {
  calculate: (data) => api.post('/shipping/calculate', data).then(r => r.data)
};

export const questionnaireAPI = {
  recommend: (data) => api.post('/questionnaire/recommend', data).then(r => r.data)
};
